import React, { useEffect, useState } from 'react';
import { Navigation } from '../components/website/navigation';
import { Link } from 'react-router-dom';

 function SubscriptionConfirmation() {
    const [update, setUpdate] = useState(false);
    useEffect(() => { 
        const queryParams = new URLSearchParams(window.location.search);
        const update = queryParams.get('update');
        setUpdate(update);
    }, []);
    
    return (
        <div className='bg-[#F3F3F3] font-nunito min-h-screen'>
            <Navigation />
            <div className='flex flex-col items-center justify-center h-screen'>
                {update ?
                (<div className='container mx-auto px-4 text-center'>
                    <h1 className='text-4xl font-bold text-center text-gray-800 mb-4'>You have updated your subscription!</h1>
                    <p>A confirmation email has been sent to your email address, with a receipt and subscription details.</p>
                    <Link to="/fleet-planning-pro" className='text-blue-600'>Go try out the app!</Link>
                </div>)
                : (<div className='container mx-auto px-4 text-center'>
                    <h1 className='text-4xl font-bold text-center text-gray-800 mb-4'>Thank you for subscribing!</h1>
                    <p>A confirmation email has been sent to your email address, with a receipt and subscription details.</p>
                    <Link to="/fleet-planning-pro" className='text-blue-600'>Go try out the app!</Link>
                </div>)}
            </div>
        </div>
    )
};

export default SubscriptionConfirmation;